import { useEffect } from 'react';
import { useSelectUnarchivingBackgroundJob } from 'redux/hooks/backgroundJobs';
import { useSelectUnarchivingResults } from 'redux/hooks/unarchiving';
import { useRMDispatch } from 'redux/hooks';
import { fetchUndismissedUnarchivingJobResultsThunk } from 'redux/thunks/unarchiving';
import { isUnarchivingJobActive } from '../hooks/useArchivingProgressHub';
import { hasActiveUnarchivingJobInResults } from './utils';

// True while an unarchive job is queued or running. Combines the live hub-backed background job
// with the current results rows, which cover the window right after submit (before the hub reports
// InProgress) and page reloads.
export const useIsUnarchivingJobActive = (): boolean => {
  const unarchivingJob = useSelectUnarchivingBackgroundJob();
  const unarchivingResults = useSelectUnarchivingResults();

  return (
    isUnarchivingJobActive(unarchivingJob) ||
    hasActiveUnarchivingJobInResults(unarchivingResults)
  );
};

export const useFetchUndismissedUnarchivingJobResults = (jobId?: string | null) => {
  const dispatch = useRMDispatch();
  const unarchivingResults = useSelectUnarchivingResults();

  useEffect(() => {
    // See Result (?jobId=) loads that job on its own; don't race it with all undismissed rows.
    if (jobId || unarchivingResults.length > 0) {
      return;
    }
    dispatch(fetchUndismissedUnarchivingJobResultsThunk());
  }, [jobId, unarchivingResults.length, dispatch]);
};
